import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Button, IconButton, makeStyles, Drawer, List, ListItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core';

//IMAGENES
import Logo from './Logo-GobiernoCorrientes-300x52.png';
//import Teclado from './pcteclado_01.jpg'

//ICONOS
import DescriptionIcon from '@material-ui/icons/Description';
import MenuIcon from '@material-ui/icons/Menu';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import PhoneIcon from '@material-ui/icons/Phone';
//import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import parse from "html-react-parser";

const useStyles = makeStyles({
    //ESTILOS PARA BOTONES DEL HEADER
    buttonHeader: {
        fontSize: 15,
        '&:hover': {
            color: 'white'
        }
    },
    //ESTILOS PARA LOS BOTONES DE REDIRECCION ARRIBA DEL VIDEO 1ºER Y EN EL 1ER VIDE
    buttonRedirect: {
        color: '#1abc9c',
        '&:hover': {
            color: 'black'
        }
    },
    //ESTILOS PARA LOS BOTONES QUE VISUALIZAN PDF
    buttonPDF: {
        color: '#232f20cf',
        fontSize: 20,
        '&:hover': {
            color: 'black',
            fontWeight: 'bold',
        }
    },
    //ESTILO PARA LOS BOTONES LINK DEL FOOTER
    linkFooter: {
        color: '#5D615F',
        fontSize: 16,
        '&:hover': {
            color: 'white'
        }
    },
    //ESTILO PARA TITULOS DE SITIOS DE INTERES
    titleFooter: {
        color: '#969998',
    },
    iconPhone: {
        color: 'green',
        marginBottom: 1,
        marginRight: 1
    }
});



const Landing = () => {
    const classes = useStyles();
    //ESTADOS
    const [verMenu, setVerMenu] = useState(false);
    //CERRAR MENU IZQUIERDA
    const toggleDrawer = (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setVerMenu(false);
    };
    return (
        <>
            <div className="d-flex flex-row justify-content-center p-3" style={{ backgroundColor: "#7FB850" }}>
                <div className="d-flex flex-row justify-content-between col-12 col-md-9">
                    <div id="logo">
                        <Link to="/"><img src={Logo} alt="Corrientes Logo" style={{ width: 230, height: 40 }} /></Link>
                    </div>
                    <div className="d-none d-md-block">
                        <div className="d-flex flex-row align-items-center">
                            <Link to="/inicio">
                                <Button className={`mr-2 ${classes.buttonHeader}`}><PersonIcon className="mr-2" />Ingresar</Button>
                            </Link>
                            <Link to="/consulta">
                                <Button className={`mr-2 ${classes.buttonHeader}`}><SearchIcon className="mr-2" />Consultar estado</Button>
                            </Link>
                            {/*<Link to="/ayuda">
                                <Button className={`mr-2 ${classes.buttonHeader}`}><HelpOutlineIcon className="mr-2" />Ayuda</Button>
                            </Link>*/}
                        </div>
                    </div>
                    <div className="d-block d-md-none">
                        <IconButton size="medium" onClick={() => setVerMenu(true)}>
                            <MenuIcon fontSize="large" />
                        </IconButton>
                        <Drawer anchor="right" open={verMenu} onClose={toggleDrawer} style={{ backgroundColor: '#b1dc8e9c' }}>
                            <List style={{ backgroundColor: '#3752219c', minHeight: '100vh', fontSize: 25 }}>
                                <ListItem button onClick={() => setVerMenu(false)}>
                                    <ListItemIcon style={{ color: "white" }}><ChevronRightIcon /></ListItemIcon>
                                </ListItem>
                                <Divider />
                                <Link to="/inicio" className="text-white">
                                    <ListItem button>
                                        <ListItemIcon style={{ color: "white" }}><PersonIcon /></ListItemIcon>
                                        <ListItemText primary="Ingresar" />
                                    </ListItem>
                                </Link>
                                <Link to="/consulta" className="text-white">
                                    <ListItem button>
                                        <ListItemIcon style={{ color: "white" }}><SearchIcon /></ListItemIcon>
                                        <ListItemText primary="Ver Estado" />
                                    </ListItem>
                                </Link>
                            </List>
                        </Drawer>
                    </div>
                </div>
            </div>
            <div style={{ backgroundColor: '#237343ab' }}>
                <div className="container emphasis-title text-white text-center" style={{ fontSize: 35 }}>
                    <br />
                    <h2 className="mx-auto font-body" style={{ maxWidth: 700, fontSize: 40 }}>Inscripciones online</h2>
                    <h1>Ciclo Lectivo {process.env.REACT_APP_CicloLectivoActual}</h1>
                    <div style={{ marginTop: 35, marginBottom: 35 }}>
                        <h3>Para saber el resultado de la inscripción consulte el estado <Link to="/consulta" className="text-warning">aquí</Link></h3>
                    </div>
                    <p className="lead mx-auto bottommargin text-left" style={{ maxWidth: 850 }}>
                        Las inscripciones estarán habilitadas en las siguientes fechas:<br />
                        Para el <strong>Nivel Inicial</strong> {parse(process.env.REACT_APP_NivelInicialPeriodo)}<br />
                        Para el <strong>Nivel Primario</strong> {parse(process.env.REACT_APP_NivelPrimarioPeriodo)}<br />
                        Para el <strong>Nivel Secundario</strong> {parse(process.env.REACT_APP_NivelSecundarioPeriodo)}
                    </p>
                    <p className="lead mx-auto bottommargin text-left" style={{ maxWidth: 850 }}>
                        Los establecimientos que NO se encuentren en los siguientes listados es porque no poseen lugares disponibles.
                        {/* Los alumnos que ya tengan una vacante asignada por el proceso de inscripción anterior no podrán realizar una nueva inscripción. */}
                    </p>
                    <div className="lead mx-auto text-left mt-5 mb-8" style={{ maxWidth: 850 }}>
                        <a className={classes.buttonPDF} href="/reports/Res5330-22.pdf" target="_blank" rel="noopener noreferrer"><DescriptionIcon /> Norma Legal</a><br />
                        {/*<a className={classes.buttonPDF} href={`/reports/${process.env.REACT_APP_CicloLectivoActual}/PrimerLlamado/ListadoEstablecimientosInscOnlineINI.pdf`} target="_blank" rel="noopener noreferrer"><DescriptionIcon /> Lista de Establecimientos Nivel Inicial</a><br />*/}
                        {/*<a className={classes.buttonPDF} href="/reports/2023/PrimerLlamado/ListadoEstablecimientosInscOnlinePRI.pdf" target="_blank" rel="noopener noreferrer"><DescriptionIcon /> Lista de Establecimientos Nivel Primario</a><br />*/}
                        {/*<a className={classes.buttonPDF} href="/reports/2023/PrimerLlamado/ListadoEstablecimientosInscOnlineSEC.pdf" target="_blank" rel="noopener noreferrer"><DescriptionIcon /> Lista de Establecimientos Nivel Secundario</a>*/}
                    </div>
                </div>
            </div>
            <br />
            <div className="d-flex flex-row justify-content-center">
                <div className="mb-10">
                    <h1 className="text-center pt-5 mb-2">
                        {/*<a className={classes.buttonRedirect} href="InstructivoPreincripciónOnline-V8.pdf">Instructivo: Inscripción Online {process.env.REACT_APP_CicloLectivoActual}</a>*/}
                        <a className={classes.buttonRedirect} href="InstructivoPreincripciónOnline-V8.pdf">Establecimientos con vacantes</a>
                    </h1>
                    <a className={classes.buttonPDF} href={`/reports/${process.env.REACT_APP_CicloLectivoActual}/SegundoLlamadoRestantes/ListadoEstablecimientosInscOnlineINI.pdf`} target="_blank" rel="noopener noreferrer"><DescriptionIcon /> Lista de Establecimientos Nivel Inicial</a><br />
                    <a className={classes.buttonPDF} href={`/reports/${process.env.REACT_APP_CicloLectivoActual}/SegundoLlamadoRestantes/ListadoEstablecimientosInscOnlinePRI.pdf`} target="_blank" rel="noopener noreferrer"><DescriptionIcon /> Lista de Establecimientos Nivel Primario</a><br />
                    <a className={classes.buttonPDF} href={`/reports/${process.env.REACT_APP_CicloLectivoActual}/SegundoLlamadoRestantes/ListadoEstablecimientosInscOnlineSEC.pdf`} target="_blank" rel="noopener noreferrer"><DescriptionIcon /> Lista de Establecimientos Nivel Secundario</a><br />

                    {/*<h2 className="text-center pt-5 pb-2">*/}
                    {/*    ¿Cómo registrarse en la página <a className={classes.buttonRedirect} href="https://inscripciones.mec.gob.ar" target="_blank" rel="noopener noreferrer">inscripciones.mec.gob.ar</a>?*/}
                    {/*</h2>*/}
                    {/*<iframe className="pb-5 col-12" title="registrarse" width="auto" height="480" src="https://www.youtube.com/embed/MqNLT1oVOiQ" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>*/}
                    {/*<h2 className="text-center pt-5 pb-2 mt-3">*/}
                    {/*    ¿Cómo realizar la inscripción desde la Página Web?*/}
                    {/*</h2>*/}
                    {/*<iframe className="pb-5 col-12" title="realizar" width="853" height="480" src="https://www.youtube.com/embed/boIzLfa3h3c" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>*/}
                </div>
            </div>
            <div className="pb-5 pt-4" style={{ backgroundColor: '#282828' }}>
                <div className="container">
                    <div className="row mx-auto clearfix">
                        <div className="col-md-4 pb-5">
                            <h2 className={classes.titleFooter}>Sitios de Interés Nacional</h2>
                            <ul className="list-unstyled footer-site-links mb-0">
                                <li><a className={classes.linkFooter} href="https://www.educ.ar/" target="_blank" rel="noopener noreferrer" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Educ.ar</a></li>
                                <li><a className={classes.linkFooter} href="https://asociacioneducar.com/" target="_blank" rel="noopener noreferrer" data-scrollto="#section-services" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Neurociencias y Educación</a></li>
                                <li><a className={classes.linkFooter} href="https://sites.google.com/crearvalelapena.org.ar/entornoscreativos" target="_blank" rel="noopener noreferrer" data-scrollto="#section-blog" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Fundación Crear Vale la Pena</a></li>
                                <li><a className={classes.linkFooter} href="https://www.argentina.gob.ar/educacion" target="_blank" rel="noopener noreferrer" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Ministerio de Educación de la Nación</a></li>
                                <li><a className={classes.linkFooter} href="https://www.argentina.gob.ar/educacion/aprender-conectados" target="_blank" rel="noopener noreferrer" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Plan Nacional Integral de Educación Digital</a></li>
                            </ul>
                        </div>

                        <div className="col-md-4 pb-5">
                            <h2 className={classes.titleFooter}>Sitios de Interés Provincial</h2>
                            <ul className="list-unstyled footer-site-links mb-0">
                                <li><a className={classes.linkFooter} href="http://aprendemostodos.mec.gob.ar/" target="_blank" rel="noopener noreferrer" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Aprendemos todos</a></li>
                                <li><a className={classes.linkFooter} href="http://www.dgescorrientes.net/" target="_blank" rel="noopener noreferrer" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Dirección de Nivel Superior</a></li>
                                <li><a className={classes.linkFooter} href="https://www.mec.gob.ar/" target="_blank" rel="noopener noreferrer" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Ministerio de Educación de Corrientes</a></li>
                                <li><a className={classes.linkFooter} href="https://www.corrientes.gob.ar/" target="_blank" rel="noopener noreferrer" data-easing="easeInOutExpo" data-speed="1250" data-offset="70">Gobierno de la Provincia de Corrientes</a></li>
                            </ul>
                        </div>

                        <div className="col-md-4 pb-5">
                            <h2 className={classes.titleFooter}>Mesas de Ayuda</h2>
                            <h4 className="text-white"><PhoneIcon className={classes.iconPhone} />Teléfonos:</h4>
                            <div className={classes.linkFooter}>(0379) - 4469755</div>
                            <div className={classes.linkFooter}>(0379) - 4464558</div>
                            <div className={classes.linkFooter}>0800-888-2790</div>
                            <br />
                            <h4 className="text-white"><WhatsAppIcon className={classes.iconPhone} /> WhatsApp:</h4>
                            <div className={classes.linkFooter}>+54 9 3794 29-5989</div>
                            <div className={classes.linkFooter}>+54 9 3794 29-5953</div>
                            <div className={classes.linkFooter}>+54 9 3794 80-7006</div>
                        </div>
                    </div>
                </div>
                <h3 className={`pt-5 pb-5 text-center ${classes.titleFooter}`}>Ministerio de Educación de Corrientes</h3>
            </div>
        </>
    )
}

export default Landing;